const SiteFooter = () => {
  return (
    <footer className="w-full border-t border-white/20 mt-auto glassmorphism">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-700 dark:text-gray-300">© 2024 LinguaLearn. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default SiteFooter;
